// src/router/origensDestinos.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

const origensDestinosBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'OrigensDestinos',
        to: 'OrigensDestinos'
    }
]

export default [
    {
        path: '/origens-destinos',
        name: 'OrigensDestinos',
        component: () => import('@/views/OrigensDestinos/OrigemDestinoListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Origens/Destinos',
            breadcrumb: origensDestinosBreadCrumb
        },
    },
    {
        path: '/origens-destinos/novo',
        name: 'OrigemDestinoNovo',
        component: () => import('@/views/OrigensDestinos/NovoOrigemDestinoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Origem/Destino',
            breadcrumb: [
                ...origensDestinosBreadCrumb,
                {
                    label: 'Nova Origem/Destino',
                    to: 'ClienteNovo'
                }
            ]
        }
    },
    {
        path: '/origens-destinos/:id/edit',
        name: 'OrigemDestinoEdit',
        component: () => import('@/views/OrigensDestinos/NovoOrigemDestinoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes da Origem/Destino',
            breadcrumb: [
                ...origensDestinosBreadCrumb,
                {
                    label: 'Nova Origem/Destino',
                    to: 'OrigemDestinoNovo'
                }
            ]
        }
    }

];
